export const getAgentTemplatesUrl = () => 'agency/agent_templates';
